import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppService } from '../core/config/app.service';
import { Router, NavigationEnd, RouterOutlet, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FooterComponent } from './footer';
import { HeaderComponent } from './header';
import { SidebarComponent } from './sidebar';
import { ThemeCustomizerComponent } from './theme-customizer';
import { NgClass } from '@angular/common';
import { AdminAuthStateService } from '../core/auth/auth.service';
import { AdminUserProfileState } from '../core/services/admin-user-profile.state';
import { PermissionService } from '../core/services/permission.service';
import { AdminRbacLiveSyncService } from '../core/services/admin-rbac-live-sync.service';

@Component({
    selector: 'app-root',
    templateUrl: './app-layout.html',
    standalone: true,
    imports: [
        NgClass,
        ThemeCustomizerComponent,
        SidebarComponent,
        HeaderComponent,
        RouterOutlet,
        FooterComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppLayout implements OnInit, OnDestroy {
    private readonly service = inject(AppService);
    private readonly authState = inject(AdminAuthStateService);
    private readonly profileState = inject(AdminUserProfileState);
    private readonly permissionService = inject(PermissionService);
    private readonly rbacLiveSync = inject(AdminRbacLiveSyncService);
    readonly store = this.service.indexState;

    showTopButton = false;
    currentModule: string = '';

    constructor(public translate: TranslateService, public storeData: Store<any>, private readonly router: Router, private readonly activatedRoute: ActivatedRoute) {
        this.currentModule = this.activatedRoute.snapshot?.url[0]?.path || '';
        
    }
    headerClass = '';
    ngOnInit() {
        if (this.authState.getToken()) {
            this.profileState.loadFromApi();
            this.permissionService.ensureLoaded().subscribe();
            this.rbacLiveSync.start();
        }
        this.initAnimation();
        this.toggleLoader();
        globalThis.addEventListener('scroll', () => {
            if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                this.showTopButton = true;
            } else {
                this.showTopButton = false;
            }
        });
    }

    ngOnDestroy() {
        this.rbacLiveSync.stop();
        globalThis.removeEventListener('scroll', () => {});
    }

    initAnimation() {
        this.service.changeAnimation();
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.service.changeAnimation();
            }
        });

        const ele: any = document.querySelector('.animation');
        ele.addEventListener('animationend', () => {
            this.service.changeAnimation('remove');
        });
    }

    toggleLoader() {
        this.storeData.dispatch({ type: 'toggleMainLoader', payload: true });
        setTimeout(() => {
            this.storeData.dispatch({ type: 'toggleMainLoader', payload: false });
        }, 500);
    }

    goToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
}
